'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What types of web hosting do you offer?",
    answer: "We provide shared hosting, VPS hosting, cloud hosting, and dedicated server options based on your project size and traffic requirements. Our team helps you choose the best plan for performance, reliability, and scalability."
  },
  {
    question: "How secure is the web hosting you provide?",
    answer: "Security is our top priority. Our hosting includes firewalls, DDoS protection, malware scanning, SSL certificates, and regular backups to keep your website safe and running smoothly 24/7."
  },
  {
    question: "Do you offer website backups and recovery options?",
    answer: "Yes, we perform automated backups and offer easy recovery options in case of accidental data loss, hacking attempts, or server issues — ensuring your website is always protected."
  },
  {
    question: "Can you help migrate my existing website to your hosting?",
    answer: "Absolutely. We handle the entire migration process for you — with zero downtime and no data loss — whether you’re moving from another hosting provider or upgrading your current setup."
  },
  {
    question: "Do you monitor websites for uptime and threats?",
    answer: "Yes. We offer real-time monitoring to detect downtime, suspicious activity, and performance issues. Our team acts fast to resolve any threats and maintain uninterrupted service."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div
        className="col text-center py-5 mt-5"
        data-aos="fade-up"
        data-aos-delay="100"
        data-aos-duration="500"
        data-aos-once="true"
      >
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="500"
          data-aos-once="true"
        >
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
